document.addEventListener('DOMContentLoaded', () => {

   // Copyright current Year
   const currentYear = new Date().getFullYear();

   function replaceTextNodes(node) {
      if (node.nodeType === Node.TEXT_NODE) {
         if (node.nodeValue.includes('${current-year}')) {
            node.nodeValue = node.nodeValue.replace(/\$\{current-year\}/g, currentYear);
         }
      } else if (node.nodeType === Node.ELEMENT_NODE && node.nodeName !== "SCRIPT" && node.nodeName !== "STYLE") {
         for (let child of node.childNodes) {
            replaceTextNodes(child);
         }
      }
   }

   replaceTextNodes(document.body);
});
